<template>
  <div class="details_form_item">
    <Form :model="dataModel" :label-width="100">
       <FormItem label="日志类型：">{{dataModel.dLogType}}</FormItem>
      <FormItem label="日志代码：">{{dataModel.dLogCode}}</FormItem>
      <FormItem label="接口名：">{{dataModel.dLogTitle}}</FormItem>
      <FormItem label="输出内容：">{{dataModel.dLogContent}}</FormItem>
      <FormItem label="说明：">{{dataModel.dLogExplain}}</FormItem>
      <FormItem label="输出时间：">{{dataModel.dLogDate}}</FormItem>
    </Form>
    <div class="ml-5 mt-5 text-center modal-foter">
      <Button @click="returnBack">关 闭</Button>
    </div>
  </div>
</template>
<script>
export default {
  props: ["currentData"],
  components: {},
  data: function () {
    return {
      dataModel: {},
    };
  },

  created: function () {
    this.dataModel = this.currentData;
  },

  methods: {
    returnBack: function () {
      this.$emit("close");
    },
  },
};
</script>
<style scoped>
</style>